import { defineComponent as _defineComponent } from 'vue';
import { ValidationProvider } from 'vee-validate';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzFormField',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var fieldRef = ref();
    expose({
      validate: function validate() {
        var _fieldRef$value;
        return (_fieldRef$value = fieldRef.value) === null || _fieldRef$value === void 0 ? void 0 : _fieldRef$value.validate();
      }
    });
    return {
      __sfc: true,
      fieldRef: fieldRef,
      ValidationProvider: ValidationProvider
    };
  }
});